// extracted by mini-css-extract-plugin
export default {"grid":"Totals_grid__f+-cM","item":"Totals_item__6xPXR","label":"Totals_label__SKtY6","value":"Totals_value__-6xms"};